<template>
  <section
    class="bg-white fixed z-20 top-0 left-0 w-screen h-screen bg-opacity-40 bg-blur flex items-center justify-center"
  >
    <div class="bg-gray-100 bg-opacity-90 p-8 rounded shadow-2xl w-96">
      <div>
        <div class="flex justify-between items-center mb-4">
          <h2 class="font-bold text-2xl">Manage</h2>
          <button @click="closeModal" class="font-bold text-2xl">x</button>
        </div>
      </div>

      <el-form label-position="left" label-width="100px" :model="form">
        <el-form-item label="Name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="Type">
          <el-checkbox v-model="form.feature">Flower</el-checkbox>
          <el-checkbox v-model="form.change">Bouquet</el-checkbox>
        </el-form-item>

        <el-form-item label="Color">
          <el-input type="" v-model="form.color"></el-input>
        </el-form-item>

        <el-form-item label="Price">
          <el-input type="" v-model="form.price"></el-input>
        </el-form-item>

        <el-form-item label="Count">
          <el-input type="number" v-model="form.count"></el-input>
        </el-form-item>

        <el-form-item label="Description">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>

        <upload-image
          :description="'Cropped at 3x2.'"
          cropOptions="3:4"
          label="Image of Flower"
          required="true"
          v-model="form.image"
          class="mr-2"
        />

        <button
          @click="updateFlower()"
          class="font-bold text-md text-gray-800 bg-yellow-100 py-2 px-4 rounded-full mt-4"
        >
          Save
        </button>
      </el-form>
    </div>
  </section>
</template>
<script>
import UploadImage from "@/components/UploadImage.vue";
import { db } from "@/db";
export default {
  props: {
    value: Object,
  },
  components: {
    UploadImage,
  },
  data: function () {
    return {
      form: Object,
    };
  },
  mounted() {
    this.form = this.value;
  },
  firestore: {
    flowers: db.collection("flowers"),
  },
  methods: {
    closeModal() {
      this.$emit("exit", true);
    },
    updateFlower() {
      // if flower exists
      if (this.form.id) {
        this.$firestoreRefs.flowers
          .doc(this.form.id)
          .update(this.form)
          .then(() => {
            console.log("flower updated!");
          });
      } else {
        // if flower does not exists, create it
        db.collection("flowers").add(this.form);
      }
      this.closeModal();
    },
  },
};
</script>